import { LEAD_STATUS_COLORS } from "@/lib/constants";

const hexToRgba = (hex, a) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export default function StatusBadge({ status, color, className = "", testId }) {
  const c = color || LEAD_STATUS_COLORS[status] || "#6C757D";
  return (
    <span
      data-testid={testId || "status-badge"}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${className}`}
      style={{ backgroundColor: hexToRgba(c, 0.14), color: c }}
    >
      <span className="status-dot" style={{ backgroundColor: c }} />
      {status}
    </span>
  );
}
